module.exports = __webpack_public_path__ + "img/gc_country_flag_lv.112b855c.svg";